// Product page: show which sizes exist in the chosen colour and, once a size is chosen, which colours have it (2026-10-18).
// Reads the stock JSON from ls2-offer-calc and re-applies after the theme re-renders the variant picker.
(() => {
  if (window.__lsVariantAvailability) return;
  window.__lsVariantAvailability = true;

  const picked = new Set();
  let frame = 0;

  const readStock = () => {
    const element = document.querySelector('script[data-ls2-stock]');
    if (!element) return null;
    try { return JSON.parse(element.textContent); } catch (_) { return null; }
  };

  const apply = () => {
    frame = 0;
    const stock = readStock();
    const selects = document.querySelector('variant-selects');
    if (!stock || !selects) return;
    const fieldsets = [...selects.querySelectorAll('fieldset')];
    const chosen = fieldsets.map((fieldset) => fieldset.querySelector('input:checked')?.value ?? null);

    fieldsets.forEach((fieldset, index) => {
      // Earlier options (colour) always narrow later ones (size); a later option narrows earlier ones only once the shopper picked it.
      const constraints = chosen
        .map((value, other) => ({ value, other }))
        .filter(({ value, other }) => other !== index && value !== null && (other < index || picked.has(other)));

      fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
        const available = stock.variants.some(
          (variant) => variant.a && variant.o[index] === input.value && constraints.every(({ value, other }) => variant.o[other] === value)
        );
        const label = selects.querySelector(`label[for="${input.id}"]`);
        input.classList.toggle('ls-oos', !available);
        label?.classList.toggle('ls-oos', !available);
      });
    });
  };

  const schedule = () => { if (!frame) frame = requestAnimationFrame(apply); };

  document.addEventListener('change', (event) => {
    const selects = event.target.closest?.('variant-selects');
    if (!selects) return;
    if (event.isTrusted) picked.add([...selects.querySelectorAll('fieldset')].indexOf(event.target.closest('fieldset')));
    schedule();
  });

  const start = () => {
    const root = document.querySelector('variant-selects')?.closest('section, .shopify-section, product-info') || document.body;
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
